// FinalCta.jsx
import React from "react";
import { Container, Form, Button } from "react-bootstrap";
import { MdCheck, MdArrowForward } from "react-icons/md";
import "./CheckInLanding.css";

const features = [
    "Secure & private",
    "No tracking",
    "Pause anytime",
    "Cancel anytime",
];

const FinalCta = () => {
    return (
        <section className="final-cta-section">
            <Container>
                <div className="final-cta-wrapper">

                    <div className="final-cta-badge">
                        <span>— A modern personal safety solution</span>
                    </div>

                    <h2 className="final-cta-title mt-4">
                        Don't let worry get in the way of{" "}
                        <em>living.</em>
                    </h2>

                    <p className="cta-desc">
                        If you’re ready to prioritize your safety, start your subscription today.
                    </p>

                    <Form className="cta-form">
                        <Form.Control
                            type="email"
                            placeholder="you@example.com"
                            className="cta-input"
                        />

                        <Button className="cta-btn">
                            Sign up
                            <MdArrowForward size={18} />
                        </Button>
                    </Form>

                    <div className="cta-features">
                        {features.map((item, index) => (
                            <span key={index} className="cta-feature-item">
                                <MdCheck size={14} />
                                {item}
                            </span>
                        ))}
                    </div>

                </div>
            </Container>
        </section>
    );
};

export default FinalCta;